import { Constants } from "../globals/index.js";

export default class ExpiryLocalStorageUtils {
  static getArrayValueAsJson(key, expiryMinutes) {
    const array = JSON.parse(localStorage.getItem(key)) || []
    return array.filter(item => (item.createdAt + (expiryMinutes * 60 * 1000)) > Date.now())
  }

  static getArrayValueAsJsonThenReplace(key, expiryMinutes, replacer) {
    const origin = ExpiryLocalStorageUtils.getArrayValueAsJson(key, expiryMinutes)
    return ExpiryLocalStorageUtils.setArrayValueAsJson(key, replacer(origin))
  }

  static setArrayValueAsJson(key, value) {
    return localStorage.setItem(key, JSON.stringify(value))
  }

  static getInflowCampaignIds() {
    return ExpiryLocalStorageUtils
        .getArrayValueAsJson(Constants.STORAGE_KEY_CAMPAIGN_INFLOW_LIST, 30)
        .map(item => item.campaignId)
  }
}
